import React, { useEffect, useState } from 'react';
import './Skills.css';
import { getSkills } from '../queries/getSkills';

import { FaReact, FaNodeJs, FaJava, FaPython, FaGitAlt, FaLinux, FaBootstrap, FaDocker, FaAngular, FaAndroid, FaApple } from 'react-icons/fa';
import { SiTypescript, SiPostgresql, SiMysql, SiMongodb, SiFirebase, SiJavascript, SiHtml5, SiCss3, SiTailwindcss, SiExpress, SiMicrosoftazure, SiGithubactions, SiNextdotjs, SiRemix, SiMui, SiVite, SiOracle, SiPostman, SiFlutter, SiExpo, SiGoogleplay } from 'react-icons/si';
import { Skill } from '../types';

const iconMap: { [key: string]: JSX.Element } = {
  // Programming Languages
  "Python": <FaPython />,
  "Java": <FaJava />,
  "C": <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>C</span>,
  "JavaScript": <SiJavascript />,
  "TypeScript": <SiTypescript />,

  // Frontend Technologies
  "React": <FaReact />,
  "React Native": <FaReact />,
  "Expo": <SiExpo />,
  "Flutter": <SiFlutter />,
  "Android Dev": <FaAndroid />,
  "iOS Dev (Swift)": <FaApple />,
  "App Store": <SiGoogleplay />,
  "Next.js": <SiNextdotjs />,
  "Remix": <SiRemix />,
  "HTML/CSS": <><SiHtml5 style={{ marginRight: '4px' }} /><SiCss3 /></>,
  "Tailwind CSS": <SiTailwindcss />,
  "Bootstrap": <FaBootstrap />,
  "Material UI": <SiMui />,
  "Vite": <SiVite />,
  "Angular": <FaAngular />,
  "Dotnet": <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>C#</span>,

  // Backend Technologies
  "Node.js": <FaNodeJs />,
  "Express.js": <SiExpress />,

  // Database Technologies
  "PostgreSQL": <SiPostgresql />,
  "MySQL": <SiMysql />,
  "MongoDB": <SiMongodb />,
  "Firebase": <SiFirebase />,
  "Oracle": <SiOracle />,

  // DevOps & Tools
  "Git": <FaGitAlt />,
  "Linux & Bash": <FaLinux />,
  "Docker": <FaDocker />,
  "CI/CD (GitHub Actions)": <SiGithubactions />,
  "Azure": <SiMicrosoftazure />,
  "Postman": <SiPostman />,
};


const Skills: React.FC = () => {

  const [skillsData, setSkillsData] = useState<Skill[]>([]);

  useEffect(() => {
    async function fetchSkills() {
      const data = await getSkills();
      setSkillsData(data);
    }

    fetchSkills()
  }, []);

  if (skillsData.length === 0) return <div>Loading...</div>;

  const skillsByCategory = skillsData.reduce((acc: any, skill: any) => {
    if (!acc[skill.category]) acc[skill.category] = [];
    acc[skill.category].push(skill);
    return acc;
  }, {});


  return (
    <div className="skills-container">
      <h1 className="skills-title">Skills</h1>
      {Object.keys(skillsByCategory).map((category, index) => (
        <div key={index} className="skill-category">
          <h2 className="category-title">{category}</h2>
          <div className="skills-grid">
            {skillsByCategory[category].map((skill: any, idx: number) => (
              <div key={idx} className="skill-card">
                <div className="icon">{iconMap[skill.name] || <FaReact />}</div>
                <h3 className="skill-name">
                  {skill.name.split('').map((letter: any, i: number) => (
                    <span key={i} className="letter" style={{ animationDelay: `${i * 0.05}s` }}>
                      {letter}
                    </span>
                  ))}
                </h3>
                <p className="skill-description">{skill.description}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Skills;
